import type { OptionGroup } from '@/types';

// An option group can require a selection two ways: the explicit `required`
// flag, or a `min` >= 1. Admin lets a group be saved with min >= 1 while
// `required` is false; treating those as optional let the customer skip the
// group and then be unable to add the product to the cart (SC-107). Both the
// quick-add gate and the modal's step/footer logic must use the same rule, so
// it lives here once.

type RequirementShape = Pick<OptionGroup, 'required' | 'min'>;

/** Minimum number of options the customer must pick from this group. */
export function minRequired(g: RequirementShape): number {
  return Math.max(g.required ? 1 : 0, g.min ?? 0);
}

/** True when the customer must pick at least one option from this group. */
export function isEffectivelyRequired(g: RequirementShape): boolean {
  return minRequired(g) > 0;
}
